import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order-card-details" }
const _hoisted_2 = { class: "d-flex justify-space-between font-size-18-600" }
const _hoisted_3 = { class: "d-flex justify-space-between font-size-10-400" }
const _hoisted_4 = { class: "text-right" }
const _hoisted_5 = { class: "mt-1" }
const _hoisted_6 = { class: "mt-1" }
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = { class: "mt-1" }
const _hoisted_9 = { class: "d-flex align-center ga-12 justify-space-between mt-9" }
const _hoisted_10 = { class: "font-size-10-400 error-color pa-2" }

import {inject, computed, shallowRef, onMounted, watch} from 'vue';
import ButtonBase from "@/components/custom/ButtonBase.vue";
import {cartService} from "@/api/services/cart";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShopCartOrderSummary',
  props: {
  item: {
    type: Object,
  },
},
  setup(__props) {

const props = __props;

const cartData = shallowRef<string>(null);
const isCouponApplied = shallowRef<boolean>(false);
const couponCode = shallowRef<string | null>(null);
const errorMessage = shallowRef<string>('');

const snackBarPlugin = inject('snackbar');

const getSupplier = computed(() => {
  return props.item?.supplier ?? 'clinic';
});

const getClinicAvatar = computed(() => {
  if (getSupplier.value == 'clinic') {
    return props.item?.clinic_avatar?.file?.file_path ?? '';
  }
  return '/img/tnd_hands_logo.png';
});

const getItemsCount = computed(() => {
  let quantity = 0;

  cartData.value?.items.forEach((item) => {
    quantity += item.quantity;
  });

  return quantity ?? 0;
});

const getDiscount = computed(() => {
  if (cartData.value?.discount_code) {
    return `-${props.item?.currency}${cartData.value.discount.toFixed(2)}`;
  }

  return `${props.item?.currency}0.00`;
});

const disableApplyButton = computed(() => {
  return !couponCode.value || isCouponApplied.value;
});

const getCartPrice = computed(() => {
  return (cartData.value?.total_retail - cartData.value?.tax - cartData.value?.discount).toFixed(2);
});

const onApplyCoupon = () => {
  cartService.applyDiscount(cartData.value.id, couponCode.value)
      .then((response) => {
        isCouponApplied.value = true;
        errorMessage.value = '';

        if (response.cart) {
          cartData.value = response.cart;
          snackBarPlugin.successSnackbar('Coupon applied successfully');
        }
      })
      .catch((error) => {
        errorMessage.value = 'Failed to apply coupon';
        snackBarPlugin.errorSnackbar('Failed to apply coupon');
        console.error(error);
      });
};

const onRemoveCoupon = () => {
  cartService.removeDiscount(cartData.value.id)
      .then((response) => {
        isCouponApplied.value = false;
        couponCode.value = null;
        errorMessage.value = '';

        if (response.cart) {
          cartData.value = response.cart;
          snackBarPlugin.successSnackbar('Coupon removed successfully');
        }
      })
      .catch((error) => {
        errorMessage.value = 'Failed to remove coupon';
        snackBarPlugin.errorSnackbar('Failed to remove coupon');
        console.error(error);
      });
};

watch(() => props.item, (newVal) => {
  cartData.value = newVal;
});

onMounted(() => {
  cartData.value = props.item;
  if (cartData.value.discount_code) {
    isCouponApplied.value = true;
    couponCode.value = cartData.value.discount_code.code;
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_v_sheet, {
        class: _normalizeClass([{
        'clinic-logo-border secondary-background-button-color': getSupplier.value === 'clinic', 
        'logo-default-border': getSupplier.value?.name !== 'clinic'
      }, "logo-container__content"])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            style: _normalizeStyle({backgroundImage: `url(${getClinicAvatar.value})`}),
            class: "logo-container__image"
          }, null, 4)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_v_card_text, { class: "card-description pa-0" }, {
        default: _withCtx(() => [
          _createElementVNode("section", _hoisted_2, [
            _createElementVNode("div", null, _toDisplayString(getItemsCount.value) + " items ", 1),
            _createElementVNode("div", null, _toDisplayString(__props.item?.currency) + _toDisplayString((cartData.value?.total_retail - cartData.value?.discount).toFixed(2)), 1)
          ]),
          _createElementVNode("section", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "font-grey-dark" }, [
              _createElementVNode("p", { class: "mt-1" }, "Items SubTotal:"),
              _createElementVNode("p", { class: "mt-1" }, "Tax:"),
              _createElementVNode("p", { class: "mt-1" }, "Discount:"),
              _createElementVNode("p", { class: "mt-1" }, "Shipping:")
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(__props.item?.currency) + _toDisplayString(getCartPrice.value), 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(__props.item?.currency) + _toDisplayString(cartData.value?.tax.toFixed(2)), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(getDiscount.value), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(__props.item?.currency) + _toDisplayString(cartData.value?.total_shipping.toFixed(2)), 1)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createVNode(_component_v_text_field, {
        modelValue: couponCode.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((couponCode).value = $event)),
        disabled: isCouponApplied.value,
        class: "input-round-20",
        density: "compact",
        elevation: "0",
        "hide-details": "",
        placeholder: "Coupon code",
        rounded: "",
        variant: "solo",
        width: "100%"
      }, null, 8, ["modelValue", "disabled"]),
      _createElementVNode("div", null, [
        (!isCouponApplied.value)
          ? (_openBlock(), _createBlock(ButtonBase, {
              key: 0,
              disabled: disableApplyButton.value,
              "custom-class": "text-white b-round-20 outline-btn white-btn",
              text: "Apply",
              width: "104px",
              onClick: onApplyCoupon
            }, null, 8, ["disabled"]))
          : (_openBlock(), _createBlock(ButtonBase, {
              key: 1,
              "custom-class": "text-white b-round-20 outline-btn remove-btn",
              text: "Remove",
              width: "104px",
              onClick: onRemoveCoupon
            }))
      ])
    ]),
    _createElementVNode("p", _hoisted_10, _toDisplayString(errorMessage.value), 1)
  ], 64))
}
}

})